/* NYXO — predictive-search.js
   Debounced predictive search via the Section Rendering API. */
(function () {
  'use strict';
  var input = document.querySelector('[data-predictive-input]');
  var results = document.querySelector('[data-predictive-results]');
  if (!input || !results) return;

  var routes = (window.NYXO && window.NYXO.routes) || {};
  var endpoint = routes.predictiveSearch || '/search/suggest';
  var timer = null;
  var controller = null;

  input.addEventListener('input', function () {
    var q = input.value.trim();
    window.clearTimeout(timer);
    if (q.length < 2) { results.innerHTML = ''; return; }
    timer = window.setTimeout(function () {
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = endpoint + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,article,page,query&resources[limit]=6&section_id=predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tpl = document.createElement('div');
          tpl.innerHTML = html;
          var section = tpl.querySelector('.predictive');
          results.innerHTML = section ? section.outerHTML : '';
        })
        .catch(function (err) { if (err && err.name !== 'AbortError') results.innerHTML = ''; });
    }, 260);
  });
})();
